import { useEffect, useRef, useState } from "react";
import { EMAIL } from "../data";

/**
 * Intercepts clicks on any mailto: link, copies the address to the clipboard, and
 * shows a confirmation toast (falling back to the default mail action if the
 * clipboard write fails).
 */
export function EmailCopyToast() {
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState("");
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const link = (e.target as Element)?.closest?.('a[href^="mailto:"]') as
        | HTMLAnchorElement
        | null;
      if (!link) return;
      e.preventDefault();
      navigator.clipboard
        .writeText(EMAIL)
        .then(() => {
          setMsg("Email copied ✓");
          setShow(true);
          clearTimeout(timer.current);
          timer.current = setTimeout(() => setShow(false), 2400);
        })
        .catch(() => {
          window.location.href = link.href;
        });
    };
    document.addEventListener("click", onClick);
    return () => {
      document.removeEventListener("click", onClick);
      clearTimeout(timer.current);
    };
  }, []);

  return <div className={`toast${show ? " show" : ""}`}>{msg}</div>;
}
